export default "__VITE_PUBLIC_ASSET__3faa51cb__"